import React from "react";
import { AppBar, Toolbar, Button } from "@material-ui/core";
import { Link, Box, Menu, Text } from "common";
import { useStyles } from "./CreateBundleNav.style";
import { clearCreationBundleForm } from "store/actions/bundlePromotion.actions";
import { useDispatch, useSelector } from "react-redux";
import { clearApi } from "store/actions/api.actions";
import { CREATE_RESOURCE } from "store/store.types";
import { IState } from "store/store.interface";

interface IRoutes {
  label: string;
  to: string;
}

function CreateBundleNav() {
  const classes = useStyles();
  const dispatch = useDispatch();

  const bundleRoutes: IRoutes[] = [
    { label: "Cart Bundles", to: "/cart-bundles" },
    { label: "Bulk Upload Jobs", to: "/bulk-campaign-jobs" },
    { label: "Cart Bundle Help", to: "/cart-bundle-help" },
  ];

  const {
    recurringCountries = [],
    bundleAllowedCountries = [],
    storeId,
  } = useSelector((state: IState) => ({
    ...state.config,
    ...state.auth,
  }));

  const canShowBundles = storeId && bundleAllowedCountries.includes(storeId);
  const canShowRecurring = storeId && recurringCountries.includes(storeId);
  const canRenderNav = canShowBundles || canShowRecurring;

  const handleClick = () => {
    dispatch(clearCreationBundleForm());
    dispatch(clearApi(CREATE_RESOURCE));
  };

  const getMenuLabel = (label: string) => (
    <Text className={classes.navButton}>{label}</Text> as any
  );

  if (!canRenderNav) {
    return null;
  }

  return (
    <AppBar position="static" className={classes.appBar}>
      <Box className={classes.navButtonsWrapper}>
        <Toolbar disableGutters>
          <Box display="flex">
            <Button onClick={handleClick} className={classes.navButton}>
              <Link to="/">
                <Box>Coupons</Box>
              </Link>
              {canShowBundles && (
                <Box pl={2} className={classes.bundleHover}>
                  <Menu
                    menuLabel={getMenuLabel("Bundles")}
                    options={bundleRoutes}
                    theme="primary"
                  />
                </Box>
              )}
              {canShowRecurring && (
                <Link to="/recurring-coupons">
                  <Box pl={canShowBundles ? 1 : 2}>Recurring Coupon</Box>
                </Link>
              )}
            </Button>
          </Box>
        </Toolbar>
      </Box>
    </AppBar>
  );
}
export default CreateBundleNav;
